<template>
    <div class="mold-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('prototyping.title')}}
                <hr>
            </span>
        </h1>
        <div class="row">
            <h2>{{$t('prototyping.introTtile')}}</h2>
            <p>{{$t('prototyping.introText')}}</p>
        </div>

        <!-- PROTOTYPING -->
        <div class="sevices-row">
            <div class="row">
                <div class="col-sm-6 sevice-left">
                    <div class="sevice-img-box">
                        <img class="img-responsive" src="../../assets/images/tom-claes-hMP2mme5yG0-unsplash.png" alt="">
                    </div>
                </div>
                <div class="col-sm-6 sevice-content">
                    <h1>{{$t('prototyping.title')}}</h1>
                    <ul>
                        <li v-for="(item,index) in proIcon[$i18n.locale]" :key="index">
                            <img class="img-responsive" :src="item.url" alt="">
                            <span>{{item.title}}</span>
                        </li>
                    </ul>
                    <p>{{$t('prototyping.tips')}}</p>
                </div>
            </div>
        </div>

        <div class="row mold-row">
            <ul class="pic-list">
                <li v-for="(item,index) in moldingTrialsList[$i18n.locale]" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p>{{item.text}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                moldingTrialsList:"",
                proIcon:{
                    EN:[
                        {
                            url:require('../../assets/images/CNC.png'),
                            title:"CNC"
                        },{
                            url:require('../../assets/images/3D Printer.png'),
                            title:"3D PRINTING"
                        },{
                            url:require('../../assets/images/outline.png'),
                            title:"URETHANE CASTING"
                        }
                    ],
                    CN:[
                        {
                            url:require('../../assets/images/CNC.png'),
                            title:"CNC"
                        },{
                            url:require('../../assets/images/3D Printer.png'),
                            title:"3D 列印"
                        },{
                            url:require('../../assets/images/outline.png'),
                            title:"软胶铸造模"
                        }
                    ],
                    CHT:[
                        {
                            url:require('../../assets/images/CNC.png'),
                            title:"CNC"
                        },{
                            url:require('../../assets/images/3D Printer.png'),
                            title:"3D 列印"
                        },{
                            url:require('../../assets/images/outline.png'),
                            title:"軟膠鑄造模"
                        }
                    ],
                    JP:[
                        {
                            url:require('../../assets/images/CNC.png'),
                            title:"CNC"
                        },{
                            url:require('../../assets/images/3D Printer.png'),
                            title:"3Dプリンター"
                        },{
                            url:require('../../assets/images/outline.png'),
                            title:"ウレタン鋳造型"
                        }
                    ]
                },
                teamsImg:[
                    {url:require('../../assets/images/Dell_logo_2016.png')},
                    {url:require('../../assets/images/Nvidia-logo-01.png')},
                    {url:require('../../assets/images/group_28.png')}
                ]
            }
        },
        methods:{
            getMoldingTrialsList(){
                this.$api.moldingTrials.moldingTrialsList().then(res=>{
                    this.moldingTrialsList =res.data.result
                    console.log(res.data.result)
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            }
        },
        mounted(){
            $(document).ready(function(){
                if($(window).width()>768){
                    $(".sevice-img-box").height($(".sevice-content").height());
                }
            })
            this.getMoldingTrialsList()
        }
    }
</script>

<style scoped>
.mold-content h2{
    font-weight: 700;
    font-size: 2.4rem;
    margin:0 auto;
    margin-bottom: 2rem;
}
 .sevices-row{
        width:100%;
        background:#091932;
        padding:2rem 0;
    }
    .sevices-row h1{
        font-size: 4.8rem;
        color:#fff;
        font-weight: 700;
        text-align: left;
    }
    .sevices-row p{
        width: 100%;
        color:#fff;
        font-size: 2rem;
        text-align: left;
        margin:4rem 0;
    }
    .sevices-row ul{
        margin-top:4rem
    }
    .sevices-row ul li{
        overflow: hidden;
        margin-top: 2rem;
    }
    .sevices-row ul li img{
        float: left;
        width:6rem;
        margin: 0 auto;
    }
    .sevices-row ul li span{
        float: left;
        font-size: 1.4rem;
        font-weight: bold;
        color: #fff;
        margin-top: 2rem;
        margin-left: 2rem;
    }
    .sevice-img-box{
        display: table-cell;
        vertical-align: middle;
        width: 100%;
    }
    .sevice-img-box img{
        width: 100%;
        border:25px solid #fff;
    }
    .sevice-content{
        padding-left:8rem;
    }
@media (min-width:768px) and (max-width:1024px){
    .sevice-content{
        padding-left: 2rem;
    }
    .sevices-row h1{
       font-size:  2.4rem;
    }
    .sevices-row p{
        font-size: 1.4rem;
    }
    .sevices-row ul li img{
        width: 4rem;
    }
}
@media (max-width: 767px){
    .mold-content h2{
        font-size: 1.2rem;
    }
    .sevice-content{
        padding:0 1rem;
    }
    .sevices-row .row{
            margin:0 auto;
        }
        .sevices-row h1{
            text-align: center;
            font-size: 1.5rem;
            margin-top: 1rem;
        }
        .sevices-row .row p{
            font-size: 0.7rem;
            margin:1rem 0;
            padding:0;
        }
        .sevices-row .btn{
            margin:1rem auto
        }
        .sevices-row ul{
            margin-top: 2rem;
            padding-left: 2rem;
            margin-bottom: 2rem;
        }
        .sevices-row ul li{
            margin-top: 1rem;
        }
        .sevices-row ul li img{
            width: 3rem;
        }
        .sevices-row ul li span{
            font-size: 0.7rem;
            margin-top: 1rem;
        }
}
</style>


// WEBPACK FOOTER //
// src/views/Services/Prototyping.vue